import React, { Component } from 'react'
import { connect } from 'react-redux'
import Formsy from 'formsy-react'
import { Link, withRouter } from 'react-router-dom'
import { Icon, Button } from 'antd'
import CustomInput from '../../components/CustomInput'
import {
  sendResetPasswordEmail,
} from './actions'
import css from './index.scss'

const azship = require('../../assets/img/azship.png')
const azshipLogoText = require('../../assets/img/azshiplogohor.png')

class ForgotPassword extends Component {
  state = {
    email: '',
  }
  handleSendEmail = () => {
    this.props.sendResetPasswordEmail(this.state.email)
    this.setState({
      email: '',
    })
  }
  render() {
    return (
      <div className={css.contaier}>
        <div className={css.leftContainer}>
          <div className={css.row} style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <img
              src={azshipLogoText}
              alt="AZShip"
              className={css.logoText}
            />
            <div
              tabIndex={0}
              role="button"
              onClick={() => this.props.history.push('/login')}
            >
              <Link
                to="/login"
              >
                <Icon type="arrow-left" theme="outlined" style={{ marginRight: 16 }} />
                <span className={css.backText}>Voltar ao login</span>
              </Link>
            </div>
          </div>
          <div className={css.column} style={{ marginTop: 74 }}>
            <span className={css.bigTitle}>
              Esqueceu sua senha?
            </span>
            <span className={css.backText} style={{ marginTop: 12 }}>
              Você receberá um email em alguns minutos.
            </span>
          </div>
          <div style={{ marginTop: 44 }}>
            <Formsy
              className={css.formsy}
              onValidSubmit={this.handleSendEmail}
            >
              <div className={css.column}>
                <CustomInput
                  name="email"
                  label="Email"
                  placeholder="Digite seu email"
                  onChange={e => this.setState({ email: e.target.value })}
                  value={this.state.email}
                  validations="isEmail"
                  validationError="Email inválido."
                  required
                />
                <Button
                  type="primary"
                  size="large"
                  style={{ marginTop: 16 }}
                  loading={this.props.isApplicationLoading}
                  htmlType="submit"
                >
                  Enviar Email
                </Button>
              </div>
            </Formsy>
          </div>
          <div className={css.footer}>
            <span>
              © 2018 AZShip
            </span>
            <span>
              Privacidade
            </span>
            <span>
              Termos
            </span>
          </div>
        </div>
        <div className={css.rightContainer}>
          <img
            alt="AZShip"
            src={azship}
            className={css.azshipFlow}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isApplicationLoading: state.application.isApplicationLoading,
})

const mapActionsToProps = dispatch => ({
  sendResetPasswordEmail(email) {
    dispatch(sendResetPasswordEmail(email))
  },
})

export default withRouter(connect(mapStateToProps, mapActionsToProps)(ForgotPassword))
